export const MAX_BULK_EMAIL_RECIPIENTS = 500
export const MAX_SEQUENCE_ENROLLMENTS_PER_EMAIL_INTEGRATION = 500
